
/// <amd-module name="Environments/EnvironmentsCommon/Utils" />
import { EnvironmentResource, EnvironmentResourceReference } from "DistributedTask/Client/Contracts/TaskAgent";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface IResourceContributionFooterButtonCallbackProps {
    /**
     * callback to change the visibility of the panel footer buttons
     * */
    updateButtonVisibility: (visible: boolean) => void;

    /**
     * callback to update the text in the forward button
     * */
    setForwardButtonText: (text: string) => void;

    /**
     * callback to update the text in the back button
     * */
    setBackButtonText: (text: string) => void;
    /**
     * On the basis of contributed data enable or disable create button
     */
    onCreateButtonStatusUpdate: (isCreateButtonDisabled: boolean) => void;
}

export interface IResourceCreatedResponse {
    /**
     * Callback after resource has been successfully created by contribute
     */
    onSuccess: (resource: EnvironmentResourceReference | undefined | null) => void;

    /**
     * Error during resource creation by contribute
     */
    onError: (errorMessage: string | undefined | null) => void;
}

export interface IResourceContributionProps extends IVssComponentProperties {
    /**
     * Parent instance id
     */
    parentInstanceId: string;

    /**
     * Enviroment id 
     */
    environmentId: number | undefined | null;

    /**
     * Environment name 
     */
    environmentName: string | undefined;

    /**
     * Callback after resource has been created by contribute
     */
    onResourceCreated: IResourceCreatedResponse;

    /**
     * Give signal to contribute for resource create
     */
    createResourceSignal: boolean;

    /**
     * Url to directly land on the current view
     */
    urlToCurrentView: string | undefined;

    /**
     *  Flag informing if the component being loaded to edit a resource
     */
    isEditMode?: boolean;

    /**
     *  Resource that is being edited in case isEditMode is true
     */
    resource?: EnvironmentResource;

    /**
     * Additional properties that may be relevant to the resource
     */
    properties?: { [key: string]: any }

    /**
     * Callbacks to update the buttons in the footer of the host panel
     * */
    footerButtonCallbacks: IResourceContributionFooterButtonCallbackProps;

    /**
     * Class name of the content header
     */
    headerClassName: string;
}

export function getErrorMessage(error: any): string {
    let errorMessage: string = error ? error.message || error : "";
    return errorMessage;
}

export class EnvironmentTabKeys {
    public static EnvironmentResourcesTabKey = "resources";
    public static EnvironmentDeploymentsTabKey = "deployments";
    public static EnvironmentChecksTabKey = "checks";
}

export class ResourceSectionTypes {
    public static Kubernetes = "kubernetesSection";
    public static VmProvider = "vmProviderSection";
    public static newVmProvider = "virtualMachineProviderSection";
};

export namespace UrlParamKeys {
    export const CreateNew = "createNew";
    export const EnvironmentName = "name";
    export const Description = "description";
}
